import TickerLogo from "../../shared/TickerLogo";
import { MarketIconContainer } from "./style";

interface IMarketIconProps {
  instrumentName?: string;
  size?: number;
}
function MarketIcon({ instrumentName, size = 28 }: IMarketIconProps) {
  return (
    <MarketIconContainer>
      <TickerLogo instrumentName={instrumentName} size={size} />
    </MarketIconContainer>
  );
}

export default MarketIcon;
